import React from "react";
import { Box, Button } from "@mui/material";

const PrimaryButton = ({ onClick, label, sx = {}, startIcon }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "26px", marginBottom: "16px" }}>
      <Button
        variant="contained"
        startIcon={startIcon}
        sx={{
          // width: "60%",
          borderRadius: "50px",
          background: "linear-gradient(90deg, #771615 0%, #FF9800 100%)",
          "&:hover": { background: "linear-gradient(90deg, #771615 0%, #FF9800 100%)" },
          ...sx, // Allow additional styles to be passed
        }}
        onClick={onClick}
      >
        {label}
      </Button>
    </Box>
  );
};

export default PrimaryButton;